import React from 'react';
import styles from './style.module.scss';

export const Divider = () => <div className={styles.divider} />;
